var _rect, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 93,
    viewBox: "0 0 92 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.74255,
    y: 12.6636,
    width: 63.3069,
    height: 67.0314,
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.8911,
    y: 26.7041,
    width: 50.5545,
    height: 50.2735,
    fill: "url(#pattern1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3710_1417",
    transform: "scale(0.00719424 0.00675676)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_3710_1417",
    transform: "scale(0.00900901)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3710_1417",
    width: 139,
    height: 148,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIsAAACUAgMAAADe9zIiAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAADFBMVEUQV3b///8QV3YAAACpoEmPAAAAAnRSTlMAAHaTzTgAAAABYktHRAMRDEzyAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH5gQSDwIlcTeaEwAAARdJREFUWMPt0kGOwyAMBVDEklN0OfJ5mi7mND7EdO/FjOTxKQttCJCk4EVUqapZJEh5ir8Nzj1fQPExTecOccIKE9fA+GRoaBzw2Di5bkzgap8yh7+NAakjx979f8/4x1au5zURXErR/fUtPzsTyf6hL/LbJk6Gm1LxP60BBAlCdalouC2VMs+xc7CV8ew83Y8yYC61ruXnKkLCMJdaZw64TKDMYGp7z8aX7jb3B8qIyyg7xo2Mq/pNRmQ5AB4bXz7k9BsD7dB3TRW0Y/CFZpwHFCbfvJ7ZX2bMmDHzaeaZNWPGjBkzZt7BnBTm6yADRxlUGDrIsMKIxqDCkMKwwojGoMKQwrDCiMagwpDCiMagwpDCiJmDzQ29U2BNfQ8T2AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_3710_1417",
    width: 111,
    height: 111,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG8AAABvAgMAAACfq3bzAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAADFBMVEVJp8P///9Jp8MAAACgd7nJAAAAAnRSTlMAAHaTzTgAAAABYktHRAMRDEzyAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH5gQSDwIlcTeaEwAAAUpJREFUSMfd10HOgyAQBWDDkqNwnnofD1H3LmoCc8q/VhhH5k1Jado/6aSb5ovwNDE8h+EYRzTE8mccx4swT3e8/xButiEhpIJRY2CkqUZHB1KNQeJyxnxhxnhGf8JtV4F0xijRVUgSQ42TQKoxHugU0oFe48QYNC6MpDEWdACpoEc4ZwwI14yEMO3oXkfa0WOcHxgwrm0kjGlD14O0obdwbmGwcG0hdWFqoDORGug78foGhk68fQqpE+OXkOfx2n8FTxN/CYONt39Bb+P1U+hsvDxH++Gmt9B8RGsLzRudW2je6NhC616SOstk2DYacWd18so8bcRxk+4JMo9qGDKP6iZyS9VqeCLoQzwLaFI8E+hgPKi98Zao9/GWqDHyqqhr8qqopZassN/yqqgZlziwU/OFqI3zhajH56j4CyBHxd8ObDXuoeTR8Qe4hleD3oFm7gAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.0343ea6e3b4931eb6af524ee033a6929.svg";
export { ForwardRef as ReactComponent };